import type { Task } from "@app/core";

/**
 * Virtual recurring-occurrence ids have the form `<sourceId>::v::<iso>` (minted
 * by `expandTasksForCalendar` in @app/core). These helpers parse them; they live
 * in `lib` because both the calendar views and the task form need them.
 */
const V_SEP = "::v::";

/**
 * Split a (possibly virtual) task id into its source id and the occurrence ISO
 * it represents. A real (non-virtual) id yields `{ sourceId: id, occIso: null }`.
 */
export function splitVirtualId(id: string): { sourceId: string; occIso: string | null } {
  const idx = id.indexOf(V_SEP);
  if (idx < 0) return { sourceId: id, occIso: null };
  return { sourceId: id.slice(0, idx), occIso: id.slice(idx + V_SEP.length) };
}

/** Stable recurrence reference for occurrence mutations. A moved occurrence's
 *  `due_at` is its display time, while the virtual-id suffix remains the
 *  original expansion ISO that overrides must target. */
export function occurrenceRefOf(task: Pick<Task, "id" | "due_at">): string {
  return splitVirtualId(task.id).occIso ?? task.due_at ?? task.id;
}
